// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarPaisesService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/pais`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
